import React from "react";
import styled from "styled-components";

const Score = styled.div`
  position: absolute;
  right: 58px;
  top: 30px;
  width: 471px;
  height: 118px;
  background: url(${require("@assets/img/cardgame/score_bg.png")}) no-repeat;
  &:before {
    content: "점수";
    color: #39405f;
    font-size: 45px;
    position: absolute;
    left: 145px;
    top: 35px;
  }
`;

const ScoreIcon = styled.div`
  position: absolute;
  left: 45px;
  top: 20px;
  width: 70px;
  height: 70px;
  background: url(${require("@assets/img/traingame/ticon.png")}) no-repeat;
`;

const ScoreNum = styled.span`
  width: 150px;
  right: 55px;
  top: 0;
  position: absolute;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 67px;
  color: #39405f;
`;

const CardGameScore = ({ score }) => {
  return (
    <Score>
      <ScoreIcon />
      <ScoreNum>{score}</ScoreNum>
    </Score>
  );
};
export default React.memo(CardGameScore);
